module.exports = __webpack_public_path__ + "static/media/tesla-go-drive.6a5971ad.png";